import { render, staticRenderFns } from "./MarkedWrapper.vue?vue&type=template&id=90d9d41a&"
import script from "./MarkedWrapper.vue?vue&type=script&lang=js&"
export * from "./MarkedWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MarkedWrapper.vue?vue&type=style&index=0&id=90d9d41a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports